import React from 'react';
import classes from './Footer.scss';

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={classes.container}>
            <span>&copy; {currentYear} Twain Sport</span>
        </footer>
    );
};
